// 导入组件，组件必须声明 name
import PermissionIcon from './src';

// 为组件提供 install 安装方法，供按需引入
PermissionIcon.install = function (Vue) {
    Vue.component(PermissionIcon.name, PermissionIcon)
};

// 导出组件
export default PermissionIcon;